import "./JadwalForm.css";
import React, { Component } from "react";
import __ from "lodash";
import { URL_AKM, CONFIG_API_BE } from "../../../../../config";
import akmApi from "../../../../../apis/akmApi";
import accountManagement from "../../../../../apis/accountManagement";
import eduprimeApi from "../../../../../apis/eduprimeApi";
import LoaderModal from "../../../../modal/LoaderModal";
import Loader from "../../../../Loader";
import { Form, Row, Col } from "react-bootstrap";
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import DropdownSekolah from "../../masterDropDown/DropdownSekolah";
import DropdownKota from "../../masterDropDown/DropdownKota";
import DropdownProvinsi from "../../masterDropDown/DropdownProvinsi";
import AutocompleteSearchDinas from "./components/AutocompleteSearchDinas";
import AutocompleteSearchProvince from "./components/AutocompleteSearchProvince";
import AutocompleteSearchCity from "./components/AutocompleteSearchCity";
import AutocompleteSearchSekolah from "./components/AutocompleteSearchSekolah";
import { scheduleError } from "./scheduleFeedback";
import { isPemetaanProfile, readPemetaanReadiness, pemetaanStatusText, pemetaanNextStep } from "./pemetaanReadiness";

class JadwalForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            isLoading: false,
            jadwal: props.jadwal || {},
            profil: {},
            provinsi: [],
            kota: [],
            sekolah: [],
            scope: props.jadwal && props.jadwal.idSekolah != null ? 2 : (props.jadwal && props.jadwal.idDinas != null ? 3 : 1),
            idProvinsi: "",
            idKota: "",
            kelasOptions: [],
            kelasLoading: false,
            kelasError: "",
            formError: "",
            pemetaanReadiness: null,
            readinessLoading: false,
            readinessError: "",
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.setState({
            jadwal: this.props.jadwal,
        });
        if (this.props.jadwal.idSekolah != null && !this.isLegacyClasslessEdit()) {
            this.setState({ scope: 2 });
            this.fetchProvinsi();
            this.getSekolahById(this.props.jadwal.idSekolah);
        }
        if (!this.props.jadwal.idJadwalProfilCbt && !this.props.profil.idKelas) {
            this.fetchKelasProfil();
        }
        if (this.needsPemetaanReadiness()) this.fetchPemetaanReadiness();
    }

    componentWillUnmount() {
        this._unmounted = true;
        this._readinessRequestId = (this._readinessRequestId || 0) + 1;
        this._cityRequestId = (this._cityRequestId || 0) + 1;
        this._schoolRequestId = (this._schoolRequestId || 0) + 1;
        this._targetVersion = (this._targetVersion || 0) + 1;
    }

    needsPemetaanReadiness = () => !this.state.jadwal.idJadwalProfilCbt && isPemetaanProfile(this.props.profil);

    selectedPemetaanReady = () => !this.state.readinessLoading && Array.isArray(this.state.pemetaanReadiness)
        && this.state.pemetaanReadiness.some(row => row.urutan === Number(this.state.jadwal.urutanPemetaan) && row.status === 'READY');

    fetchPemetaanReadiness = async () => {
        const profileId = Number(this.props.profil.idProfilCbt);
        const requestId = (this._readinessRequestId || 0) + 1;
        this._readinessRequestId = requestId;
        this.setState({readinessLoading:true, readinessError:'', pemetaanReadiness:null});
        if (!Number.isInteger(profileId) || profileId <= 0) {
            this.setState({readinessLoading:false,readinessError:'Profil belum valid. Pilih ulang profil sebelum membuat jadwal.'});
            return;
        }
        try {
            const response = await accountManagement.get('/exam/pemetaanReadiness', {params:{id:profileId}});
            if (requestId !== this._readinessRequestId) return;
            const variants = readPemetaanReadiness(response.data, profileId);
            if (!variants) {
                this.setState({readinessError:'Konfigurasi Pemetaan belum dapat dipastikan. Periksa kembali pengaturan profil.'});
                return;
            }
            const ready = variants.filter(row => row.status === 'READY');
            this.setState(previous => ({pemetaanReadiness:variants, jadwal:{...previous.jadwal,
                urutanPemetaan:ready.some(row => row.urutan === Number(previous.jadwal.urutanPemetaan))
                    ? Number(previous.jadwal.urutanPemetaan) : (ready.length === 1 ? ready[0].urutan : null)}}));
        } catch (error) {
            if (requestId === this._readinessRequestId) this.setState({readinessError:scheduleError(error)});
        } finally {
            if (requestId === this._readinessRequestId) this.setState({readinessLoading:false});
        }
    };

    isLegacyClasslessEdit = () => Boolean(this.state.jadwal.idJadwalProfilCbt) && this.state.jadwal.idKelas == null;

    fetchKelasProfil = async () => {
        const group = this.props.profil.idKelasGroup;
        if (!group) {
            this.setState({ kelasError: "Profil belum memiliki kelas atau kelompok kelas. Periksa pengaturan profil." });
            return;
        }
        this.setState({ kelasLoading: true, kelasError: "" });
        try {
            const response = await akmApi.get(URL_AKM.GET_KELAS_BY_ID_KELAS_GROUP + group);
            if (response.data.errorSchema.errorCode !== URL_AKM.SUCCESS_ERROR_CODE || !Array.isArray(response.data.data) || response.data.data.length === 0) {
                this.setState({ kelasOptions: [], kelasError: "Kelompok profil belum memiliki kelas yang dapat dijadwalkan." });
                return;
            }
            this.setState({ kelasOptions: response.data.data });
        } catch (error) {
            this.setState({ kelasOptions: [], kelasError: scheduleError(error) });
        } finally {
            this.setState({ kelasLoading: false });
        }
    };

    getSekolahById = async (idSekolah) => {
        const version = this._targetVersion || 0;
        const response = await akmApi.get(URL_AKM.GET_SEKOLAH_BY_ID + idSekolah).catch(function (error) {
            alert(error);
        });
        if (this._unmounted || version !== (this._targetVersion || 0)) return;
        if (response) {
            if (response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
                this.setState({
                    idProvinsi: response.data.data.idProvinsi,
                    idKota: response.data.data.idKabupatenKota,
                });
                this.fetchKota(response.data.data.idProvinsi);
                this.fetchSekolah(response.data.data.idKabupatenKota);
            } else {
                alert("Terjadi Kesalahan.. Pls refresh");
            }
        }
    };
    fetchProvinsi = async () => {
        this.setState({ isFetching: true });
        const response = await eduprimeApi.get(CONFIG_API_BE.API_GET_PROVINSI).catch(function (error) {
            alert(error);
        });
        if (response) {
            this.setState({ provinsi: response.data.list_provinsi, isFetching: false });
        }
    };
    fetchKota = async (idProvinsi) => {
        const request = (this._cityRequestId || 0) + 1;
        this._cityRequestId = request;
        this.setState({ isFetching: true });
        try {
            const response = await eduprimeApi.get(CONFIG_API_BE.API_GET_KAB_KOTA + idProvinsi);
            if (!this._unmounted && request === this._cityRequestId) this.setState({ kota: response.data.list_kab_kota });
        } catch (error) {
            if (!this._unmounted && request === this._cityRequestId) this.setState({ kota: [], formError: scheduleError(error) });
        } finally {
            if (!this._unmounted && request === this._cityRequestId) this.setState({ isFetching: false });
        }
    };
    fetchSekolah = async (idKota) => {
        const request = (this._schoolRequestId || 0) + 1;
        this._schoolRequestId = request;
        this.setState({ isFetching: true });
        try {
            const response = await eduprimeApi.get(CONFIG_API_BE.API_GET_SEKOLAH + idKota);
            if (!this._unmounted && request === this._schoolRequestId) this.setState({ sekolah: response.data.list_sekolah });
        } catch (error) {
            if (!this._unmounted && request === this._schoolRequestId) this.setState({ sekolah: [], formError: scheduleError(error) });
        } finally {
            if (!this._unmounted && request === this._schoolRequestId) this.setState({ isFetching: false });
        }
    };

    changeJudul = (e) => {
        this.setState((prevState) => ({ jadwal: { ...prevState.jadwal, namaJadwal: e.target.value } }));
    };
    changeJadwalMulai = (date) => {
        this.setState((prevState) => ({
            jadwal: { ...prevState.jadwal, jadwalMulai: date },
        }));
    };
    changeJadwalSelesai = (date) => {
        this.setState((prevState) => ({
            jadwal: { ...prevState.jadwal, jadwalSelesai: date },
        }));
    };
    changeJadwalReport = (date) => {
        this.setState((prevState) => ({
            jadwal: { ...prevState.jadwal, jadwalReport: date, openReportDate: date },
        }));
    };

    handleSubmit(e) {
        e.preventDefault();

        const formdata = new FormData(e.target);

        // convert FormData to json object
        // SOURCE: https://stackoverflow.com/a/46774073
        const data = {};
        formdata.forEach(function (value, prop) {
            data[prop] = value;
        });

        const idKelas = this.state.jadwal.idJadwalProfilCbt
            ? this.state.jadwal.idKelas
            : (this.props.profil.idKelas || this.state.jadwal.idKelas);
        const preserveLegacy = this.isLegacyClasslessEdit();
        if (!preserveLegacy && !idKelas) {
            this.setState({ formError: "Pilih kelas jadwal yang sesuai dengan kelompok profil." });
            return;
        }
        const scope = Number(this.state.scope);
        if (!preserveLegacy && ![1,2,3].includes(scope)) {
            this.setState({formError:'Pilih cakupan jadwal yang tersedia.'});
            return;
        }
        const idSekolah = preserveLegacy ? this.state.jadwal.idSekolah : (scope === 2 ? Number(this.state.jadwal.idSekolah) || null : null);
        const idDinas = preserveLegacy ? this.state.jadwal.idDinas : (scope === 3 ? Number(this.state.jadwal.idDinas) || null : null);
        if (!preserveLegacy && ((scope === 2 && (!Number.isInteger(idSekolah) || idSekolah <= 0)) || (scope === 3 && (!Number.isInteger(idDinas) || idDinas <= 0)))) {
            this.setState({ formError: scope === 2 ? "Pilih sekolah untuk cakupan Sekolah." : "Pilih dinas untuk cakupan Dinas." });
            return;
        }
        if (this.needsPemetaanReadiness() && !this.selectedPemetaanReady()) {
            this.setState({formError:'Pilih jenis dengan konfigurasi Pemetaan siap sebelum menyimpan jadwal.'});
            return;
        }
        this.setState({ formError: "" });

        const dataSend = {
            ["idJadwal"]: this.state.jadwal.idJadwalProfilCbt,
            ["idProfil"]: this.props.profil.idProfilCbt,
            ["namaJadwal"]: data.namaJadwal,
            ["urutanPemetaan"]: this.state.jadwal.idJadwalProfilCbt ? this.state.jadwal.urutanPemetaan : (this.needsPemetaanReadiness() ? Number(this.state.jadwal.urutanPemetaan) : null),
            ["jadwalMulai"]: data.jadwalMulai,
            ["jadwalSelesai"]: data.jadwalSelesai,
            ["jadwalReport"]: data.jadwalReport,
            ["tahunAjaran"]: this.state.jadwal.kodeTahunAjaran,
            ["idKelas"]: preserveLegacy ? null : Number(idKelas),
            ["idAdmin"]: this.props.profil.idAdmin,
            ["idSekolah"]: idSekolah,
            ["idDinas"]: idDinas,
            ["jadwalParalel"]: preserveLegacy ? null : [],
            ["jadwalSiswa"]: preserveLegacy ? null : [],
        };

        this.props.submitJadwal(dataSend);
    }

    handleBack() {
        this.props.handleBack();
    }

    handleChangeScope = async (event) => {
        const value = event.target.value;
        this._targetVersion = (this._targetVersion || 0) + 1;
        this._cityRequestId = (this._cityRequestId || 0) + 1;
        this._schoolRequestId = (this._schoolRequestId || 0) + 1;
        this.setState(previous => ({ scope: value, idProvinsi: '', idKota: '', kota: [], sekolah: [], isFetching:false, jadwal: { ...previous.jadwal, idSekolah: null, idDinas: null }, formError: "" }));
        if (Number(value) === 2) this.fetchProvinsi();
    };
    handleChangeProvinsi = async (value) => {
        this._targetVersion = (this._targetVersion || 0) + 1;
        this._cityRequestId = (this._cityRequestId || 0) + 1;
        this._schoolRequestId = (this._schoolRequestId || 0) + 1;
        this.setState(previous => ({ idProvinsi: value, idKota: '', kota: [], sekolah: [], formError: '', jadwal:{...previous.jadwal,idSekolah:null} }));
        this.fetchKota(value);
    };
    handleChangeKota = async (value) => {
        this._targetVersion = (this._targetVersion || 0) + 1;
        this._schoolRequestId = (this._schoolRequestId || 0) + 1;
        this.setState(previous => ({ idKota: value, sekolah: [], formError: '', jadwal:{...previous.jadwal,idSekolah:null} }));
        this.fetchSekolah(value);
    };
    handleChangeSekolah = async (value) => {
        // const value = event.target.value;
        this.setState((prevState) => ({
            jadwal: { ...prevState.jadwal, idSekolah: value },
        }));
    };

    handleChangeDinas = async (value) => {
        this.setState((prevState) => ({
            jadwal: { ...prevState.jadwal, idDinas: value },
        }));
    };

    renderScope() {
        if (this.isLegacyClasslessEdit()) {
            return <p>Cakupan kelas dan peserta jadwal lama dipertahankan. Perubahan di formulir ini hanya untuk nama dan waktu.</p>;
        }
        if (this.state.scope == 2) {
            return (
                <Row>
                    <Col>
                        <Form.Group controlId="scope">
                            <Form.Label>Provinsi : </Form.Label>
                            <AutocompleteSearchProvince handleChangeProvinsi={this.handleChangeProvinsi} />
                            {/* <select className="form-control" name="provinsi" id="provinsi" value={this.state.idProvinsi} onChange={this.handleChangeProvinsi}>
                                <option value="">Pilih Provinsi...</option>
                                <DropdownProvinsi provinsi={this.state.provinsi} />
                            </select> */}
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="scope">
                            <Form.Label>Kabupaten/Kota : </Form.Label>
                            <AutocompleteSearchCity key={'province-'+this.state.idProvinsi} handleChangeKota={this.handleChangeKota} idProvinsi={this.state.idProvinsi} />
                            {/* <select className="form-control" name="kota" id="kota" value={this.state.idKota} onChange={this.handleChangeKota}>
                                <option value="">Pilih Kabupaten/Kota...</option>
                                <DropdownKota kota={this.state.kota} />
                            </select> */}
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="scope">
                            <Form.Label>Sekolah : </Form.Label>
                            <AutocompleteSearchSekolah key={'city-'+this.state.idKota} handleChangeSekolah={this.handleChangeSekolah} idKota={this.state.idKota} />
                            {/* <select className="form-control" name="sekolah" id="sekolah" value={this.state.jadwal.idSekolah} onChange={this.handleChangeSekolah}>
                                <option value="">Pilih Sekolah...</option>
                                <DropdownSekolah sekolah={this.state.sekolah} />
                            </select> */}
                        </Form.Group>
                    </Col>
                </Row>
            );
        } else if (this.state.scope == 3) {
            return (
                <Row>
                    <Col sm={4}>
                        <Form.Group controlId="scope">
                            <Form.Label>Dinas : </Form.Label>
                            <AutocompleteSearchDinas handleChangeDinas={this.handleChangeDinas} />
                            {/* <select className="form-control" name="dinas" id="dinas" value={this.state.scope} onChange={this.handleChangeProvinsi}>
                            <option value="">Pilih Dinas...</option>
                        </select>                         */}
                        </Form.Group>
                    </Col>
                </Row>
            );
        } else {
            return <Row></Row>;
        }
    }

    render() {
        const { jadwal, kelasParalel, jadwalSiswa } = this.state;
        let pageTitle;
        if (jadwal.idJadwalProfilCbt) {
            pageTitle = "Edit Jadwal";
        } else {
            pageTitle = "Add Jadwal";
        }
        return (
            <section className="jadwal-form">
                <Row>
                    <Col xs={12} md={6}>
                        <h4>
                            {pageTitle} : {this.props.profil.namaProfil}
                        </h4>
                    </Col>
                    <Col xs={12} md={6} className="text-center">
                        <small>
                            Keterangan<i className="text-danger">*</i> : <br />
                            1. Jadwal Kelas untuk menjadwalkan 1 kelas paralel.
                            <br />
                            2. Jadwal Siswa untuk menjadwalkan sesuai siswa yang dipilih.
                        </small>
                    </Col>
                </Row>

                {this.state.isLoading ? (
                    <Loader />
                ) : (
                    <Form onSubmit={this.handleSubmit}>
                        <Col xs={12} md={6}>
                            <Form.Group controlId="judul">
                                <Form.Label>Nama Jadwal : </Form.Label>
                                <Form.Control type="text" name="namaJadwal" placeholder="Input Nama Jadwal..." defaultValue={jadwal.namaJadwalCbt} maxLength="100" required />
                            </Form.Group>
                        </Col>

                        {!jadwal.idJadwalProfilCbt && !this.props.profil.idKelas && (
                            <Col xs={12} md={6}>
                                <Form.Group controlId="idKelasJadwal">
                                    <Form.Label>Kelas Jadwal</Form.Label>
                                    <Form.Control as="select" name="idKelas" value={jadwal.idKelas || ""} required
                                        disabled={this.state.kelasLoading || this.state.kelasOptions.length === 0}
                                        onChange={event => {
                                            const idKelas = Number(event.target.value) || null;
                                            this.setState(previous => ({ jadwal: { ...previous.jadwal, idKelas }, formError: "" }));
                                        }}>
                                        <option value="">{this.state.kelasLoading ? "Memuat kelas..." : "Pilih kelas jadwal"}</option>
                                        {this.state.kelasOptions.map(kelas => <option key={kelas.idKelas} value={kelas.idKelas}>{kelas.namaKelas}</option>)}
                                    </Form.Control>
                                    <Form.Text>Pilih kelas dari kelompok kelas profil ini.</Form.Text>
                                </Form.Group>
                                {this.state.kelasError && <div role="alert" className="alert alert-warning">{this.state.kelasError} <button type="button" className="btn btn-link" onClick={this.fetchKelasProfil}>Muat ulang kelas</button></div>}
                            </Col>
                        )}
                        {this.state.formError && <Col xs={12}><div role="alert" className="alert alert-warning">{this.state.formError}</div></Col>}

                        {isPemetaanProfile(this.props.profil) && (
                            <Col xs={12} md={6}>
                                <Form.Group controlId="urutanPemetaan">
                                    <Form.Label>Jenis Pemetaan</Form.Label>
                                    <Form.Control as="select" name="urutanPemetaan" value={jadwal.urutanPemetaan || ""}
                                        onChange={event => {
                                            const value = Number(event.target.value) || null;
                                            this.setState(previous => ({ jadwal: { ...previous.jadwal, urutanPemetaan: value } }));
                                        }}
                                        disabled={Boolean(jadwal.idJadwalProfilCbt) || this.state.readinessLoading} required={!jadwal.idJadwalProfilCbt}>
                                        <option value="">{jadwal.idJadwalProfilCbt ? "Data lama - belum dipetakan" : "Pilih jenis Pemetaan"}</option>
                                        {[1,2,3].map(urutan => {
                                            const status = (this.state.pemetaanReadiness || []).find(row => row.urutan === urutan);
                                            return <option key={urutan} value={urutan} disabled={!jadwal.idJadwalProfilCbt && (!status || status.status !== 'READY')}>
                                                Pemetaan {urutan}{!jadwal.idJadwalProfilCbt ? ' - '+pemetaanStatusText(status && status.status) : ''}
                                            </option>;
                                        })}
                                    </Form.Control>
                                    <Form.Text>Jenis harus sesuai konfigurasi profil. Mengganti nama jadwal tidak mengganti jenis atau hasil. Untuk jenis berbeda, buat jadwal baru.</Form.Text>
                                    {!jadwal.idJadwalProfilCbt && <>
                                        <Form.Text>Status ini memeriksa konfigurasi jadwal, bukan pengesahan norma atau penafsiran hasil.</Form.Text>
                                        {this.state.readinessLoading && <p role="status">Memeriksa konfigurasi Pemetaan...</p>}
                                        {this.state.readinessError && <div role="alert" className="alert alert-warning">{this.state.readinessError}</div>}
                                        {this.state.pemetaanReadiness && !this.state.pemetaanReadiness.some(row => row.status === 'READY') && <div role="alert" className="alert alert-warning">
                                            <p>Belum ada konfigurasi Pemetaan yang siap untuk profil ini. Jadwal baru belum dapat disimpan.</p>
                                            <p>ID profil: {this.props.profil.idProfilCbt}</p>
                                            <ul className="mb-0">
                                                {this.state.pemetaanReadiness.map(row => <li key={row.urutan}>
                                                    <strong>Pemetaan {row.urutan} - {pemetaanStatusText(row.status)}.</strong> {pemetaanNextStep(row.status)}
                                                </li>)}
                                            </ul>
                                        </div>}
                                        <button type="button" className="btn btn-link" onClick={this.fetchPemetaanReadiness} disabled={this.state.readinessLoading}>Periksa konfigurasi kembali</button>
                                    </>}
                                </Form.Group>
                            </Col>
                        )}

                        <Col sm={12} style={{ marginTop: 20 }}>
                            <Form.Group>
                                <Row>
                                    <Col xs={12} lg={4} className="jadwal-date">
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDateTimePicker name="jadwalMulai" value={jadwal.jadwalMulai} onChange={this.changeJadwalMulai} label="Jadwal Mulai" onError={console.log} ampm={false} format="dd-MM-yyyy HH:mm" required />
                                        </MuiPickersUtilsProvider>
                                    </Col>
                                    <Col xs={12} lg={4} className="jadwal-date">
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDateTimePicker name="jadwalSelesai" value={jadwal.jadwalSelesai} onChange={this.changeJadwalSelesai} label="Jadwal Selesai" onError={console.log} ampm={false} format="dd-MM-yyyy HH:mm" required />
                                        </MuiPickersUtilsProvider>
                                    </Col>

                                    <Col xs={12} lg={4} className="jadwal-date">
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDateTimePicker
                                                name="jadwalReport"
                                                value={jadwal.openReportDate}
                                                onChange={this.changeJadwalReport}
                                                label="Jadwal Report & Pembahasan"
                                                onError={console.log}
                                                ampm={false}
                                                minDate={jadwal.jadwalMulai}
                                                format="dd-MM-yyyy HH:mm"
                                                required
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Col>
                                </Row>
                            </Form.Group>
                        </Col>

                        <Col xs={12} md={6} style={{ marginTop: 20 }}>
                            <Form.Group controlId="scope">
                                <Form.Label>Scope Jadwal : </Form.Label>
                                <select className="form-control" name="scope" id="scope" value={this.state.scope} onChange={this.handleChangeScope} disabled={this.isLegacyClasslessEdit()}>
                                    <option value="1">ALL</option>
                                    <option value="2">Sekolah</option>
                                    <option value="3">Dinas</option>
                                </select>
                            </Form.Group>
                        </Col>

                        <Col sm={12}>{this.renderScope()}</Col>

                        <Col style={{ marginTop: 40 }}>
                            <button type="button" className="btn btn-danger" onClick={() => this.handleBack()}>
                                <ArrowBackIosIcon fontSize="small" />
                                Batal
                            </button>
                            <button type="submit" className="btn btn-primary pull-right" disabled={this.state.kelasLoading || (!jadwal.idJadwalProfilCbt && !this.props.profil.idKelas && this.state.kelasOptions.length === 0) || (this.needsPemetaanReadiness() && !this.selectedPemetaanReady())}>
                                Simpan
                            </button>
                        </Col>
                    </Form>
                )}
                <LoaderModal isFetching={this.state.isFetching} />
            </section>
        );
    }
}

export default JadwalForm;
